import React from "react";

import ProductsHeader from "../components/products/ProductsHeader";
import ProductsGrid from "../components/products/ProductsGrid";

import bowling_stock from "../assets/data/bowling_stock.json";
import bowling_shoe_stock from "../assets/data/bowling_shoe_stock.json";

const Products = ({ type }) => {
  const containerStyle = {
    maxWidth: "100%",
    margin: "0 auto",
  };

  const pageStyle = {
    paddingTop: "100px",
    minHeight: "100vh",
  };

  return (
    <div style={pageStyle}>
      <div style={containerStyle}>
        <ProductsHeader type={type} />
        <ProductsGrid
          type={type}
          products={
            type === "balls"
              ? bowling_stock.products
              : bowling_shoe_stock.products
          }
        />
      </div>
    </div>
  );
};

export default Products;
